/**
 * Cookie Banner (Solid.js)
 * DSGVO-konform: Technisch notwendige Speicherung (Auth-Token, Session) ist
 * gemäß Art. 5(3) ePrivacy-Richtlinie von der Einwilligungspflicht ausgenommen.
 */
import { createSignal, onMount, Show } from 'solid-js';
import { storage } from '../utils/storage';
import { useTranslation } from '../context/LanguageContext';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = createSignal(false);

  onMount(() => {
    if (!storage.getItem('cookieConsent')) {
      setTimeout(() => setShowBanner(true), 600);
    }
  });

  const saveConsent = (level: 'all' | 'necessary') => {
    storage.setItem('cookieConsent', level === 'all' ? 'accepted' : 'necessary');
    storage.setItem('cookieConsentDate', new Date().toISOString());
    storage.setItem(
      'cookie_preferences',
      JSON.stringify({ functional: level === 'all', analytics: false })
    );
    setShowBanner(false);
  };

  return (
    <Show when={showBanner()}>
      <div class="cb-wrap">
        <div class="cb-inner">

          <div class="cb-text">
            <div class="cb-title">
              <span>🍪</span>
              <span>{t('cookie.title')}</span>
            </div>
            <p class="cb-desc">
              {t('cookie.description')}{' '}
              <a href="/cookie-settings" class="cb-link">{t('cookie.settingsLink')}</a>{' '}
              {t('cookie.moreInfo')}{' '}
              <a href="/datenschutz" class="cb-link">{t('cookie.privacyLink')}</a>.
            </p>
          </div>

          <div class="cb-buttons">
            <button class="cb-btn cb-btn--accept" onClick={() => saveConsent('all')}>
              {t('cookie.acceptAll')}
            </button>
            <button class="cb-btn cb-btn--necessary" onClick={() => saveConsent('necessary')}>
              {t('cookie.necessaryOnly')}
            </button>
            <a href="/cookie-settings" class="cb-btn cb-btn--settings">
              {t('cookie.settings')}
            </a>
          </div>

        </div>
      </div>
    </Show>
  );
}
